import { FETCH_ROLE, RESET_ROLE } from "../../constants/action.constants";

const initialState = {
  data: {},
};

const roleViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ROLE:
      return { data: action.payload };
    case RESET_ROLE:
      return initialState;
    default:
      return state;
  }
};

export default roleViewReducer;
